export const UserDataDictionary = {
    PersonId: 'UserTenantId',
    Email: 'Email',
    FirstName: 'FirstName',
    LastName: 'LastName',
    IsOwner: 'Master',
    RegistrationType: 'TipoCadastro',
    ReceivesPix: 'ReceivesPix',
    PagueLaId: 'PagueLaId',
    Gender: 'Sexo',
    TenantId: 'TenantId',
}